
import React from "react";
import { Redirect, Route } from "react-router-dom";
import {  Notification } from '../services/api';

function FaceScanRoute({ component: Component,user,...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        user && user.scan_type ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}

export default FaceScanRoute;
